import { StudyTypes } from 'lib/generated_constants/projects';

export const isUnmoderated = (project) =>
  project?.studyTypeId === StudyTypes.UNMODERATED_TASK;
